import { Observer } from "mobx-react";
import { device } from "../../../WSUtils/constants/mediaQueries";
import { Menu } from "primereact/menu";
import React, { useContext, useRef } from "react";
import { UserInfoContext } from "../../../WSUtils/UserInfoContext";
import styled from "styled-components";
import { getItem } from "../NavMenu/getItem";
import { Button } from "primereact/button";
import { profileItems } from "./profileItems";

export const ProfileMenu: React.FC = () => {
  const userInfo = useContext(UserInfoContext);
  const profMenu = useRef(null);

  return (
    <Observer
      render={() => (
        <>
          <StyledProfileMenu
            className="cvp-profile-menu"
            model={profileItems.map((pItem) => getItem(pItem, userInfo))}
            ref={profMenu}
            id="popup_menu"
            popup
          />

          <StyledProfileBtn
            className="cvp-profile-btn"
            icon="pi pi-user"
            onClick={(event) => profMenu.current.toggle(event)}
            aria-controls="popup_menu"
            aria-haspopup
          />
        </>
      )}
    />
  );
};

export const StyledProfileMenu = styled(Menu)`
  &.cvp-profile-menu {
    .p-menuitem-link {
      &:hover:not(:disabled) {
        background-color: var(--primary-50);
        -webkit-transition: all ease-out 0.3s;
        -moz-transition: all ease-out 0.3s;
        -o-transition: all ease-out 0.3s;
        transition: all ease-out 0.3s;

        .p-menuitem-text,
        .p-menuitem-icon {
          color: var(--primary-500);
          -webkit-transition: all ease-out 0.3s;
          -moz-transition: all ease-out 0.3s;
          -o-transition: all ease-out 0.3s;
          transition: all ease-out 0.3s;
        }
      }

      &:focus {
        box-shadow: none;
      }
    }

    .active {
      background-color: var(--primary-50);

      .p-menuitem-text,
      .p-menuitem-icon {
        color: var(--primary-500);
      }

      &:hover:not(:disabled) {
        .p-menuitem-text,
        .p-menuitem-icon {
          font-weight: 500;
          -webkit-transition: all ease-out 0.3s;
          -moz-transition: all ease-out 0.3s;
          -o-transition: all ease-out 0.3s;
          transition: all ease-out 0.3s;
        }
      }
    }

    .active.log-out {
      background-color: transparent;

      .p-menuitem-text,
      .p-menuitem-icon {
        color: var(--text-color);
      }
    }

    .log-out {
      border-top: 1px solid var(--primary-100);
      margin-top: 0.3rem;

      a {
        margin-top: 0.3rem;
      }

      @media ${device.lg} {
        display: none;
      }
    }
  }
`;

export const StyledProfileBtn = styled(Button)`
  &.cvp-profile-btn {
    &.p-button.p-button-icon-only {
      width: 2rem;
      padding: 0.45rem 0;

      @media ${device.lg} {
        width: 2.357rem;
        padding: 0.5rem 0;
      }
    }

    .pi {
      font-size: 0.9rem;

      @media ${device.lg} {
        font-size: 1rem;
      }
    }

    background-color: var(--primary-100);
    border: none;
    color: var(--primary-500);

    &:hover:not(:disabled) {
      background-color: var(--primary-50);
      color: var(--primary-300);
    }
    &:active:not(:disabled) {
      border: none;
    }
    &:focus:not(:disabled) {
      box-shadow: none;
    }
  }
`;
